import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./Home";
import PageNotFound from "./PageNotFound";

export default function Routes() {
  let url = window.location.href.replace(window.location.origin + "/", "");
  // '.com/'
  // '3000/'
  //.digital

  if (url === "en") {
    localStorage.setItem("lang", "en");
  } else {
    localStorage.setItem("lang", "tr");
  }
  return (
    <Router>
      <Switch>
        <Route path="/" component={Home} exact />
        <Route path="/en" component={Home} exact />
        <Route component={PageNotFound} />
      </Switch>
    </Router>
  );
}
